import { IComponentChildrenProps } from '@src/models/props';
import React, { createContext, FC, useState } from 'react';
import { ISelectInnerProps } from './models';

interface ISelectContext extends Pick<ISelectInnerProps, 'getValue' | 'postIcon' | 'size'> {
  controlElement: null | HTMLElement;
  setControlElement: (element: null | HTMLElement) => void;
  isGroupedOptions: boolean | undefined;
}
export const SelectContext = createContext<ISelectContext>({
  controlElement: null,
  setControlElement: () => {},
  getValue: () => '',
  isGroupedOptions: false,
});

export const SelectProvider: FC<
  IComponentChildrenProps & Pick<ISelectInnerProps, 'getValue' | 'postIcon' | 'size' | 'isGroupedOptions'>
> = ({ children, getValue, postIcon, size, isGroupedOptions }) => {
  const [controlElement, setControlElement] = useState<null | HTMLElement>(null);

  return (
    <SelectContext.Provider
      value={{
        controlElement,
        setControlElement,
        getValue,
        postIcon,
        size,
        isGroupedOptions,
      }}
    >
      {children}
    </SelectContext.Provider>
  );
};
